import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        /*404 Page*/
        {
            name: '/404',
            path: '*',
            components: {
                default: () => import('@/views/404/Main.vue'),
            },

            meta: {
                title: '404 Not Found',
                bodyClass: 'not-found-page',
                showSideBar: false,
                noTopHeader: true,
            },
        },
        {
            path: '/',
            name: 'login-page',
            component: () => import('@/views/auth/Main.vue'),

            children: [
                {
                    path: '/',
                    name: 'login-page',
                    component: () => import('@/views/auth/Login.vue'),
                    meta: {
                        title: 'Login',
                        showSideBar: false,
                        bodyClass: 'auth-body',
                        requiresGuest: true,
                        noTopHeader: true,
                    },
                },
                {
                    path: 'auth/forgot-password',
                    name: 'forgot-page',
                    component: () => import('@/components/auth/Main.vue'),
                    meta: {
                        title: 'Forgot Password',
                        showSideBar: false,
                        bodyClass: 'auth-body',
                        requiresGuest: true,
                    },
                },
                {
                    path: 'auth/reset-password/:token',
                    name: 'reset-password-page',
                    component: () => import('@/views/auth/ResetPassword.vue'),
                    meta: {
                        title: 'Reset Password',
                        showSideBar: false,
                        noFooterBar: true,
                        bodyClass: 'auth-body',
                        requiresGuest: true,
                    },
                },
                {
                    path: 'auth/create-password/:token',
                    name: 'create-password-page',
                    component: () => import('@/views/auth/CreatePassword.vue'),
                    meta: {
                        title: 'Create Password',
                        showSideBar: false,
                        noFooterBar: true,
                        bodyClass: 'auth-body',
                        requiresGuest: true,
                    },
                },
                {
                    path: 'auth/register-broker/:token',
                    name: 'register-broker-page',
                    component: () => import('@/views/auth/RegisterBroker.vue'),
                    meta: {
                        title: 'Register Broker',
                        showSideBar: false,
                        noFooterBar: true,
                        bodyClass: 'auth-body',
                        requiresGuest: true,
                    },
                },
            ],
        },

        {
            path: '/contact-us',
            name: 'contact-us-page',
            component: () => import('@/views/ContactUs.vue'),
            meta: {
                title: 'Contact Us',
                showSideBar: false,
                bodyClass: 'auth-body',
                requiresGuest: true,
            },
        },
        {
            path: '/insights',
            name: 'dashboard',
            component: () => import('@/views/insights/Main.vue'),
            children: [
                {
                    path: '/',
                    name: 'view-alerts',
                    component: () => import('@/views/insights/Alert.vue'),
                    meta: {
                        title: 'Insights | Alerts',
                        showSideBar: true,
                        requiresAuth: true,
                        permission: ['view-alerts'],
                    },
                },
                {
                    path: 'alerts',
                    name: 'view-alerts',
                    component: () => import('@/views/insights/Alert.vue'),
                    meta: {
                        title: 'Insights | Alerts',
                        requiresAuth: true,
                        showSideBar: true,
                        permission: ['view-alerts'],
                    },
                },
                {
                    path: 'activity-dashboard',
                    name: 'view-activity-dashboard',
                    component: () => import('@/views/insights/Activity.vue'),
                    meta: {
                        title: 'Insights | Activity Dashboard',
                        requiresAuth: true,
                        showSideBar: true,
                        permission: ['view-activity-dashboard'],
                    },
                },
                {
                    path: 'customer-statistics',
                    name: 'view-customer-statistics',
                    component: () => import('@/views/insights/Statistics.vue'),
                    meta: {
                        title: 'Insights | Customer Statistics',
                        requiresAuth: true,
                        showSideBar: true,
                        permission: ['view-customer-statistics'],
                    },
                },
            ],
        },
        {
            path: '/system-users',
            name: 'systems',
            component: () => import('@/views/system-users/Main.vue'),
            children: [
                {
                    path: '/',
                    name: 'view-system-users',
                    component: () => import('@/views/system-users/Users.vue'),
                    meta: {
                        title: 'System Users',
                        requiresAuth: true,
                        showSideBar: true,
                        permission: ['view-system-users'],
                    },
                },
                {
                    path: 'users',
                    name: 'view-system-users',
                    component: () => import('@/views/system-users/Users.vue'),
                    meta: {
                        title: 'System Users',
                        showSideBar: true,
                        requiresAuth: true,
                        permission: ['view-system-users'],
                    },
                },
                {
                    path: 'roles',
                    name: 'view-roles',
                    component: () => import('@/views/system-users/Roles.vue'),
                    meta: {
                        title: 'System Users | Roles & Permission',
                        requiresAuth: true,
                        showSideBar: true,
                        permission: ['view-roles'],
                    },
                },
                {
                    path: 'data-segments',
                    name: 'view-data-segments',
                    component: () =>
                        import('@/views/system-users/DataSegments.vue'),
                    meta: {
                        showSideBar: true,

                        title: 'System Users | Data Segments',
                        requiresAuth: true,
                        permission: ['view-data-segments'],
                    },
                },
                {
                    path: 'application-access',
                    name: 'view-application-access',
                    component: () => import('@/views/system-users/Access.vue'),
                    meta: {
                        showSideBar: true,

                        title: 'System Users | Application Access',
                        requiresAuth: true,
                        permission: ['view-application-access'],
                    },
                },
            ],
        },
        {
            path: '/system-logs',
            name: 'system-logs',
            component: () => import('@/views/system-logs/Main.vue'),
            meta: {
                showSideBar: true,

                title: 'System Logs',
                requiresAuth: true,
                permission: ['system-logs'],
            },
        },

        {
            path: '/download/:folder/:type/:fileName',
            name: 'download',
            component: () => import('@/views/download/Download.vue'),
            meta: {
                showSideBar: true,

                title: 'Download File',
                requiresAuth: true,
                permission: [],
            },
        },

        {
            path: '/customer-profiles',
            name: 'profile',

            component: () => import('./views/customer-profiles/Main.vue'),

            children: [
                {
                    path: '/',
                    name: 'view-customer-profile',
                    component: () =>
                        import('./views/customer-profiles/AllCustomer.vue'),
                    meta: {
                        showSideBar: true,

                        title: 'Customer Profile | All Customers',
                        requiresAuth: true,
                        permission: ['view-customer-profile'],
                    },
                },
                {
                    path: '/customer-profiles/all-customer',
                    name: 'view-customer-profile',
                    component: () =>
                        import('./views/customer-profiles/AllCustomer.vue'),
                    meta: {
                        showSideBar: true,

                        title: 'Customer Profile | All Customers',
                        requiresAuth: true,
                        permission: ['view-customer-profile'],
                    },
                },

                {
                    path: '/customer-profiles/advance-search',
                    name: 'advance-search',

                    component: () =>
                        import('./views/customer-profiles/AdvanceSearch.vue'),
                    meta: {
                        showSideBar: true,

                        title: 'Customer Profile | Advance Search',
                        requiresAuth: true,
                        permission: ['view-customer-profile'],
                    },
                },
                {
                    path: '/customer-profiles/bulk-customers-onboarding',
                    name: 'bulk-customers-onboarding',
                    component: () =>
                        import(
                            './views/customer-profiles/BulkCustomersOnboarding.vue'
                        ),
                    meta: {
                        showSideBar: true,
                        title: 'Customer Onboarding',
                        requiresAuth: true,
                        permission: ['bulk-upload'],
                    },
                },
            ],
        },
        {
            path: '/customer-profiles/customer-information/:id',
            name: 'customer-details',
            props: true,
            component: () =>
                import('./views/customer-profiles/profile-details/Main.vue'),
            children: [
                {
                    path: '/customer-profiles/customer-information/:id',
                    name: 'customer-information',
                    props: true,
                    component: () =>
                        import(
                            './views/customer-profiles/profile-details/CustomerInformation.vue'
                        ),
                    meta: {
                        showSideBar: true,

                        title: 'Customer Information | Customer Profile',
                        name: 'Customer Profile',
                        requiresAuth: true,
                        permission: ['view-customer-profile'],
                    },
                },
                {
                    path: '/customer-profiles/name-screening/:id',
                    name: 'screening-customer',
                    props: true,
                    component: () =>
                        import(
                            './views/customer-profiles/profile-details/ScreeningCustomer.vue'
                        ),
                    meta: {
                        showSideBar: true,

                        title: 'Customer Information | Name Screening',
                        name: 'Name Screening',
                        requiresAuth: true,
                        permission: ['view-customer-profile'],
                    },
                },

                {
                    path: '/customer-profiles/document-verification/:id',
                    name: 'document-verification',
                    props: true,
                    component: () =>
                        import(
                            './views/customer-profiles/profile-details/DocumentVerification.vue'
                        ),
                    meta: {
                        showSideBar: true,

                        title: 'Customer Information | Document Verification',
                        name: 'Document Verification',
                        requiresAuth: true,
                        permission: ['view-customer-profile'],
                    },
                },
                {
                    path: '/customer-profiles/kyc-risk-rating/:id',
                    name: 'kyc-risk-rating',
                    props: true,
                    component: () =>
                        import(
                            './views/customer-profiles/profile-details/KYCRiskRating.vue'
                        ),
                    meta: {
                        showSideBar: true,

                        title: 'Customer Information | KYC Risk Rating',
                        name: 'KYC Risk Rating',
                        requiresAuth: true,
                        permission: ['view-customer-profile'],
                    },
                },
                {
                    path: '/customer-profiles/activity-timeline/:id',
                    name: 'activity-timeline',
                    props: true,
                    component: () =>
                        import(
                            './views/customer-profiles/profile-details/ActivityTimeline.vue'
                        ),
                    meta: {
                        showSideBar: true,

                        title: 'Customer Information | Activity Timeline',
                        name: 'Activity Timeline',
                        requiresAuth: true,
                        permission: ['view-customer-profile'],
                    },
                },
                {
                    path: '/customer-profiles/hit-detail/:id/:hitId', // /:customerId/:hitId
                    name: 'screening-hit-detail',
                    props: true,
                    component: () =>
                        import(
                            './views/customer-profiles/profile-details/HitDetail.vue'
                        ),
                    meta: {
                        showSideBar: true,
                        previousRoute: 'screening-customer',
                        title: 'Customer Information | Hit Detail',
                        name: 'Screening Hit Detail',
                        requiresAuth: true,
                        permission: ['view-customer-profile'],
                    },
                },
                // {
                //     path: '/customer-profiles/otp-verification/:id',
                //     name: 'otp-verification',
                //     props: true,
                //     component: () =>
                //         import('./views/customer-profiles/profile-details/OtpVerification.vue'),
                //     meta: {
                //         showSideBar: true,

                //         title: 'Customer Information | OTP Verficiation',
                //         name: 'OTP Verification',
                //         requiresAuth: true,
                //         permission: ['view-customer-profile'],
                //     },
                // },
            ],
        },
        {
            path: '/configuration',
            name: 'configuration',

            component: () => import('@/views/configuration/Main.vue'),
            children: [
                {
                    path: '/',
                    name: 'idenfo-engine',
                    component: () =>
                        import('./views/configuration/idenfo-engine/Main.vue'),
                    children: [
                        {
                            path: '/',
                            name: 'idenfo-engine',
                            component: () =>
                                import(
                                    './views/configuration/idenfo-engine/RiskFactor.vue'
                                ),
                            meta: {
                                showSideBar: true,

                                title: 'Configuration | Idenfo Engine | Risk Factor & Weightage',
                                requiresAuth: true,
                                innerTabName: 'Idenfo Engine',
                                permission: ['idenfo-engine'],
                            },
                        },
                        {
                            path: '/configuration/idenfo-engine/risk',
                            name: 'conf-risk',
                            component: () =>
                                import(
                                    './views/configuration/idenfo-engine/RiskFactor.vue'
                                ),
                            meta: {
                                showSideBar: true,

                                title: 'Configuration | Idenfo Engine | Risk Factor & Weightage',
                                requiresAuth: true,
                                innerTabName: 'Idenfo Engine',
                                permission: ['idenfo-engine'],
                            },
                        },
                        {
                            path: '/configuration/idenfo-engine/',
                            name: 'idenfo-engine',
                            component: () =>
                                import(
                                    './views/configuration/idenfo-engine/RiskFactor.vue'
                                ),
                            meta: {
                                showSideBar: true,

                                title: 'Configuration | Idenfo Engine | Risk Factor & Weightage',
                                requiresAuth: true,
                                innerTabName: 'Idenfo Engine',
                                permission: ['idenfo-engine'],
                            },
                        },
                        {
                            path: '/configuration/idenfo-engine/risk-rating',
                            name: 'risk-rating',
                            component: () =>
                                import(
                                    './views/configuration/idenfo-engine/RiskRating.vue'
                                ),
                            meta: {
                                showSideBar: true,

                                title: 'Configuration | Idenfo Engine | Risk Rating Score & Risk Rating Overrides',
                                requiresAuth: true,
                                innerTabName: 'Idenfo Engine',
                                permission: ['idenfo-engine'],
                            },
                        },
                        {
                            path: '/configuration/idenfo-engine/document-verification-factor',
                            name: 'document-verification-factor',
                            component: () =>
                                import(
                                    './views/configuration/idenfo-engine/DocumentVerificationFactors.vue'
                                ),
                            meta: {
                                showSideBar: true,

                                title: 'Configuration | Idenfo Engine | Document Verification Factors',
                                requiresAuth: true,
                                innerTabName: 'Idenfo Engine',
                                permission: ['idenfo-engine'],
                            },
                        },

                        {
                            path: '/configuration/idenfo-engine/name-screen-score',
                            name: 'name-screen-score',
                            component: () =>
                                import(
                                    './views/configuration/idenfo-engine/NameScreenScore.vue'
                                ),
                            meta: {
                                showSideBar: true,

                                title: 'Configuration | Idenfo Engine | Name Screening Score Factors',
                                requiresAuth: true,
                                innerTabName: 'Idenfo Engine',
                                permission: ['idenfo-engine'],
                            },
                        },
                        {
                            path: '/configuration/idenfo-engine/nationality',
                            name: 'conf-nationality',
                            component: () =>
                                import(
                                    './views/configuration/idenfo-engine/Nationality.vue'
                                ),
                            meta: {
                                showSideBar: true,

                                title: 'Configuration | Idenfo Engine | Nationality Factor',
                                requiresAuth: true,
                                innerTabName: 'Idenfo Engine',
                                permission: ['idenfo-engine'],
                            },
                        },
                        {
                            path: '/configuration/idenfo-engine/country',
                            name: 'conf-country',
                            component: () =>
                                import(
                                    './views/configuration/idenfo-engine/Country.vue'
                                ),
                            meta: {
                                showSideBar: true,

                                title: 'Configuration | Idenfo Engine | Country of Residence Factor',
                                requiresAuth: true,
                                innerTabName: 'Idenfo Engine',
                                permission: ['idenfo-engine'],
                            },
                        },
                        {
                            path: '/configuration/idenfo-engine/state',
                            name: 'state-factor',
                            component: () =>
                                import(
                                    './views/configuration/idenfo-engine/StateFactor.vue'
                                ),
                            meta: {
                                showSideBar: true,

                                title: 'Configuration | Idenfo Engine | State Factor',
                                requiresAuth: true,
                                innerTabName: 'Idenfo Engine',
                                permission: ['idenfo-engine'],
                            },
                        },
                        {
                            path: '/configuration/idenfo-engine/work',
                            name: 'work-factor',
                            component: () =>
                                import(
                                    './views/configuration/idenfo-engine/WorkFactor.vue'
                                ),
                            meta: {
                                showSideBar: true,

                                title: 'Configuration | Idenfo Engine | Work Type Factor',
                                requiresAuth: true,
                                innerTabName: 'Idenfo Engine',
                                permission: ['idenfo-engine'],
                            },
                        },
                        {
                            path: '/configuration/idenfo-engine/industry',
                            name: 'industry-factor',
                            component: () =>
                                import(
                                    './views/configuration/idenfo-engine/IndustryFactor.vue'
                                ),
                            meta: {
                                showSideBar: true,

                                title: 'Configuration | Idenfo Engine | Industry Factor',
                                responsiveMenuItem: true,
                                innerTabName: 'Idenfo Engine',
                                requiresAuth: true,
                                permission: ['idenfo-engine'],
                            },
                        },
                        {
                            path: '/configuration/idenfo-engine/product',
                            name: 'productFactor',
                            component: () =>
                                import(
                                    './views/configuration/idenfo-engine/ProductFactor.vue'
                                ),
                            meta: {
                                showSideBar: true,

                                title: 'Configuration | Idenfo Engine | Product Factor',
                                responsiveMenuItem: true,
                                innerTabName: 'Idenfo Engine',
                                requiresAuth: true,
                                permission: ['idenfo-engine'],
                            },
                        },
                        {
                            path: '/configuration/idenfo-engine/relationship',
                            name: 'relationship-factor',
                            component: () =>
                                import(
                                    './views/configuration/idenfo-engine/RelationshipPanel.vue'
                                ),
                            meta: {
                                showSideBar: true,

                                title: 'Configuration | Idenfo Engine | Relationship Length Factor',
                                responsiveMenuItem: true,
                                innerTabName: 'Idenfo Engine',
                                requiresAuth: true,
                                permission: ['idenfo-engine'],
                            },
                        },
                        {
                            path: '/configuration/idenfo-engine/channel',
                            name: 'channel-factor',
                            component: () =>
                                import(
                                    './views/configuration/idenfo-engine/ChannelFactor.vue'
                                ),
                            meta: {
                                showSideBar: true,

                                title: 'Configuration | Idenfo Engine | Channel Type Factor',
                                responsiveMenuItem: true,
                                innerTabName: 'Idenfo Engine',
                                requiresAuth: true,
                                permission: ['idenfo-engine'],
                            },
                        },
                        {
                            path: '/configuration/idenfo-engine/purpose-of-action',
                            name: 'purpose-action',
                            component: () =>
                                import(
                                    './views/configuration/idenfo-engine/PurposeAction.vue'
                                ),
                            meta: {
                                showSideBar: true,

                                title: 'Configuration | Idenfo Engine | Purpose of Action Management',
                                responsiveMenuItem: true,
                                innerTabName: 'Idenfo Engine',
                                requiresAuth: true,
                                permission: ['idenfo-engine'],
                            },
                        },
                        {
                            path: '/configuration/idenfo-engine/gender',
                            name: 'idenfo-engine-gender',
                            component: () =>
                                import(
                                    './views/configuration/idenfo-engine/Gender.vue'
                                ),
                            meta: {
                                showSideBar: true,

                                title: 'Configuration | Idenfo Engine | Gender',
                                responsiveMenuItem: true,
                                innerTabName: 'Idenfo Engine',
                                requiresAuth: true,
                                permission: ['idenfo-engine'],
                            },
                        },
                        {
                            path: '/configuration/idenfo-engine/risk-level-review',
                            name: 'idenfo-engine-risk-level-review',
                            component: () =>
                                import(
                                    './views/configuration/idenfo-engine/RiskLevelReview.vue'
                                ),
                            meta: {
                                showSideBar: true,

                                title: 'Configuration | Idenfo Engine | Risk Level Review Configuration',
                                responsiveMenuItem: true,
                                innerTabName: 'Idenfo Engine',
                                requiresAuth: true,
                                permission: ['idenfo-engine'],
                            },
                        },
                        {
                            path: '/configuration/idenfo-engine/aum',
                            name: 'idenfo-engine-aum',
                            component: () =>
                                import(
                                    './views/configuration/idenfo-engine/AUMConfigurations.vue'
                                ),
                            meta: {
                                showSideBar: true,

                                title: 'Configuration | Idenfo Engine | AUM Configurations',
                                responsiveMenuItem: true,
                                innerTabName: 'Idenfo Engine',
                                requiresAuth: true,
                                permission: ['idenfo-engine'],
                            },
                        },
                        {
                            path: '/configuration/idenfo-engine/sar',
                            name: 'idenfo-engine-sar',
                            component: () =>
                                import(
                                    './views/configuration/idenfo-engine/SARConfigurations.vue'
                                ),
                            meta: {
                                showSideBar: true,

                                title: 'Configuration | Idenfo Engine | SAR Configurations',
                                responsiveMenuItem: true,
                                innerTabName: 'Idenfo Engine',
                                requiresAuth: true,
                                permission: ['idenfo-engine'],
                            },
                        },
                        {
                            path: '/configuration/idenfo-engine/screening-list',
                            name: 'screening-list',
                            component: () =>
                                import (
                                    './views/configuration/idenfo-engine/ScreeningListCategorizationV2.vue'
                                ),
                            meta: {
                                showSideBar: true,

                                title: 'Configuration | Idenfo Engine | Screening List Categorisation',
                                requiresAuth: true,
                                innerTabName: 'Idenfo Engine',
                                permission: ['idenfo-engine'],
                            },
                        },
                        {
                            path: '/configuration/idenfo-engine/AM',
                            name: 'idenfo-engine-am',
                            component: () =>
                                import(
                                    './views/configuration/idenfo-engine/WebSearchAMConfigurations.vue'
                                ),
                            meta: {
                                showSideBar: true,

                                title: 'Configuration | Idenfo Engine | AM Configurations',
                                responsiveMenuItem: true,
                                innerTabName: 'Idenfo Engine',
                                requiresAuth: true,
                                permission: ['idenfo-engine'],
                            },
                        },
                        {
                            path: '/configuration/idenfo-engine/Entity',
                            name: 'idenfo-engine-Entity',
                            component: () =>
                                import(
                                    './views/configuration/idenfo-engine/WebSearchEntityConfigurations.vue'
                                ),
                            meta: {
                                showSideBar: true,

                                title: 'Configuration | Idenfo Engine | Entity Configurations',
                                responsiveMenuItem: true,
                                innerTabName: 'Idenfo Engine',
                                requiresAuth: true,
                                permission: ['idenfo-engine'],
                            },
                        },

                        {
                            path: '/configuration/idenfo-engine/PEP',
                            name: 'idenfo-engine-pep',
                            component: () =>
                                import(
                                    './views/configuration/idenfo-engine/WebSearchPEPConfigurations.vue'
                                ),
                            meta: {
                                showSideBar: true,

                                title: 'Configuration | Idenfo Engine | PEP Configurations',
                                responsiveMenuItem: true,
                                innerTabName: 'Idenfo Engine',
                                requiresAuth: true,
                                permission: ['idenfo-engine'],
                            },
                        },
                        {
                            path: '/configuration/idenfo-engine/stop-words',
                            name: 'stop-words',
                            component: () =>
                                import(
                                    './views/configuration/idenfo-engine/StopWordsConfigurations.vue'
                                ),
                            meta: {
                                showSideBar: true,

                                title: 'Configuration | Idenfo Engine | Stop Words',
                                requiresAuth: true,
                                innerTabName: 'Idenfo Engine',
                                permission: ['idenfo-engine'],
                            },
                        },
                        {
                            path: '/configuration/idenfo-engine/variant-words',
                            name: 'variant-words',
                            component: () =>
                                import(
                                    './views/configuration/idenfo-engine/VariantWordsConfigurations.vue'
                                ),
                            meta: {
                                showSideBar: true,

                                title: 'Configuration | Idenfo Engine | Variant Words',
                                requiresAuth: true,
                                innerTabName: 'Idenfo Engine',
                                permission: ['idenfo-engine'],
                            },
                        },
                    ],
                },
                {
                    path: '/configuration/screening-data/',
                    name: 'client-black-list',
                    meta: {
                        showSideBar: true,
                        selectedTab: 0,
                        title: 'Configuration | Screening Data | Gender',
                        requiresAuth: true,
                        permission: ['view-screening-data'],
                    },
                    component: () =>
                        import('./views/configuration/screening-data/Main.vue'),
                    children: [
                        {
                            path: '/configuration/screening-data/gender',
                            name: 'gender',
                            component: () =>
                                import(
                                    './views/configuration/screening-data/Gender.vue'
                                ),
                            meta: {
                                showSideBar: true,
                                selectedTab: 0,
                                title: 'Configuration | Screening Data | Gender',
                                requiresAuth: true,
                                permission: ['view-screening-data'],
                            },
                        },
                        {
                            path: '/',
                            name: 'gender',
                            component: () =>
                                import(
                                    './views/configuration/screening-data/Gender.vue'
                                ),
                            meta: {
                                showSideBar: true,
                                selectedTab: 0,
                                title: 'Configuration | Screening Data | Gender',
                                requiresAuth: true,
                                innerTabName: 'Screening Data',
                                permission: ['view-screening-data'],
                            },
                        },
                        {
                            path: '/configuration/screening-data/',
                            name: 'gender',
                            component: () =>
                                import(
                                    './views/configuration/screening-data/Gender.vue'
                                ),
                            meta: {
                                showSideBar: true,
                                selectedTab: 0,
                                title: 'Configuration | Screening Data | Screening Data',
                                requiresAuth: true,
                                innerTabName: 'Screening Data',
                                permission: ['view-screening-data'],
                            },
                        },
                        {
                            path: '/configuration/screening-data/deceased',
                            name: 'deceased',
                            component: () =>
                                import(
                                    './views/configuration/screening-data/Deceased.vue'
                                ),
                            meta: {
                                showSideBar: true,
                                selectedTab: 0,
                                title: 'Configuration | Screening Data | Deceased',
                                requiresAuth: true,
                                innerTabName: 'Screening Data',
                                permission: ['view-screening-data'],
                            },
                        },
                        {
                            path: '/configuration/screening-data/record-status',
                            name: 'record-status',
                            component: () =>
                                import(
                                    './views/configuration/screening-data/RecordStatus.vue'
                                ),
                            meta: {
                                showSideBar: true,
                                selectedTab: 0,
                                title: 'Configuration | Screening Data | Record Status',
                                requiresAuth: true,
                                innerTabName: 'Screening Data',
                                permission: ['view-screening-data'],
                            },
                        },
                        {
                            path: '/configuration/screening-data/name-type',
                            name: 'name-type',
                            component: () =>
                                import(
                                    './views/configuration/screening-data/NameType.vue'
                                ),
                            meta: {
                                showSideBar: true,
                                selectedTab: 0,
                                title: 'Configuration | Screening Data | Name Type',
                                requiresAuth: true,
                                innerTabName: 'Screening Data',
                                permission: ['view-screening-data'],
                            },
                        },
                        {
                            path: '/configuration/screening-data/descprition-1',
                            name: 'descprition-1',
                            component: () =>
                                import(
                                    './views/configuration/screening-data/Descprition1.vue'
                                ),
                            meta: {
                                showSideBar: true,
                                selectedTab: 0,
                                title: 'Configuration | Screening Data | Description 1',
                                requiresAuth: true,
                                innerTabName: 'Screening Data',
                                permission: ['view-screening-data'],
                            },
                        },
                        {
                            path: '/configuration/screening-data/descprition-2',
                            name: 'descprition-2',
                            component: () =>
                                import(
                                    './views/configuration/screening-data/Descprition2.vue'
                                ),
                            meta: {
                                showSideBar: true,
                                selectedTab: 0,
                                title: 'Configuration | Screening Data | Description 2',
                                requiresAuth: true,
                                innerTabName: 'Screening Data',
                                permission: ['view-screening-data'],
                            },
                        },
                        {
                            path: '/configuration/screening-data/descprition-3',
                            name: 'descprition-3',
                            component: () =>
                                import(
                                    './views/configuration/screening-data/Descprition3.vue'
                                ),
                            meta: {
                                showSideBar: true,
                                selectedTab: 0,
                                title: 'Configuration | Screening Data | Description 3',
                                requiresAuth: true,
                                innerTabName: 'Screening Data',
                                permission: ['view-screening-data'],
                            },
                        },
                        {
                            path: '/configuration/screening-data/role-type',
                            name: 'role-type',
                            component: () =>
                                import(
                                    './views/configuration/screening-data/RoleType.vue'
                                ),
                            meta: {
                                showSideBar: true,
                                selectedTab: 0,
                                title: 'Configuration | Screening Data | Role Type',
                                requiresAuth: true,
                                innerTabName: 'Screening Data',
                                permission: ['view-screening-data'],
                            },
                        },
                        {
                            path: '/configuration/screening-data/occupation',
                            name: 'occupation',
                            component: () =>
                                import(
                                    './views/configuration/screening-data/Occupation.vue'
                                ),
                            meta: {
                                showSideBar: true,
                                selectedTab: 0,
                                title: 'Configuration | Screening Data | Occupation',
                                responsiveMenuItem: true,
                                requiresAuth: true,
                                innerTabName: 'Screening Data',
                                permission: ['view-screening-data'],
                            },
                        },
                        {
                            path: '/',
                            name: 'dow-jones-list',
                            component: () =>
                                import(
                                    './views/configuration/screening-data/dow-jones/Main.vue'
                                ),
                            children: [
                                {
                                    path: '/configuration/screening-data/dow-jones/gender',
                                    name: 'gender',
                                    component: () =>
                                        import(
                                            './views/configuration/screening-data/dow-jones/Gender.vue'
                                        ),
                                    meta: {
                                        showSideBar: true,
                                        selectedTab: 0,
                                        title: 'Configuration | Screening Data | Gender',
                                        requiresAuth: true,
                                        permission: ['dow-jones-list'],
                                    },
                                },
                                // {
                                //     path: '/',
                                //     name: 'gender',
                                //     component: () =>
                                //         import(
                                //              './views/configuration/screening-data/dow-jones/Gender.vue'
                                //         ),
                                //     meta: {
                                //         showSideBar: true,
                                //         selectedTab: 0,
                                //         title: 'Configuration | Screening Data | Gender',
                                //         requiresAuth: true,
                                //         innerTabName: 'Screening Data',
                                //         permission: ['dow-jones-list'],
                                //     },
                                // },
                                {
                                    path: '/configuration/screening-data/dow-jones',
                                    name: 'gender',
                                    component: () =>
                                        import(
                                            './views/configuration/screening-data/dow-jones/Gender.vue'
                                        ),
                                    meta: {
                                        showSideBar: true,
                                        selectedTab: 0,
                                        title: 'Configuration | Screening Data | Screening Data',
                                        requiresAuth: true,
                                        innerTabName: 'Screening Data',
                                        permission: ['dow-jones-list'],
                                    },
                                },
                                {
                                    path: '/configuration/screening-data/dow-jones/deceased',
                                    name: 'deceased',
                                    component: () =>
                                        import(
                                            './views/configuration/screening-data/dow-jones/Deceased.vue'
                                        ),
                                    meta: {
                                        showSideBar: true,
                                        selectedTab: 0,
                                        title: 'Configuration | Screening Data | Deceased',
                                        requiresAuth: true,
                                        innerTabName: 'Screening Data',
                                        permission: ['dow-jones-list'],
                                    },
                                },
                                {
                                    path: '/configuration/screening-data/dow-jones/record-status',
                                    name: 'record-status',
                                    component: () =>
                                        import(
                                            './views/configuration/screening-data/dow-jones/RecordStatus.vue'
                                        ),
                                    meta: {
                                        showSideBar: true,
                                        selectedTab: 0,
                                        title: 'Configuration | Screening Data | Record Status',
                                        requiresAuth: true,
                                        innerTabName: 'Screening Data',
                                        permission: ['dow-jones-list'],
                                    },
                                },
                                {
                                    path: '/configuration/screening-data/dow-jones/name-type',
                                    name: 'name-type',
                                    component: () =>
                                        import(
                                            './views/configuration/screening-data/dow-jones/NameType.vue'
                                        ),
                                    meta: {
                                        showSideBar: true,
                                        selectedTab: 0,
                                        title: 'Configuration | Screening Data | Name Type',
                                        requiresAuth: true,
                                        innerTabName: 'Screening Data',
                                        permission: ['dow-jones-list'],
                                    },
                                },
                                {
                                    path: '/configuration/screening-data/dow-jones/descprition-1',
                                    name: 'descprition-1',
                                    component: () =>
                                        import(
                                            './views/configuration/screening-data/dow-jones/Descprition1.vue'
                                        ),
                                    meta: {
                                        showSideBar: true,
                                        selectedTab: 0,
                                        title: 'Configuration | Screening Data | Description 1',
                                        requiresAuth: true,
                                        innerTabName: 'Screening Data',
                                        permission: ['dow-jones-list'],
                                    },
                                },
                                {
                                    path: '/configuration/screening-data/dow-jones/descprition-2',
                                    name: 'descprition-2',
                                    component: () =>
                                        import(
                                            './views/configuration/screening-data/dow-jones/Descprition2.vue'
                                        ),
                                    meta: {
                                        showSideBar: true,
                                        selectedTab: 0,
                                        title: 'Configuration | Screening Data | Description 2',
                                        requiresAuth: true,
                                        innerTabName: 'Screening Data',
                                        permission: ['dow-jones-list'],
                                    },
                                },
                                {
                                    path: '/configuration/screening-data/dow-jones/descprition-3',
                                    name: 'descprition-3',
                                    component: () =>
                                        import(
                                            './views/configuration/screening-data/dow-jones/Descprition3.vue'
                                        ),
                                    meta: {
                                        showSideBar: true,
                                        selectedTab: 0,
                                        title: 'Configuration | Screening Data | Description 3',
                                        requiresAuth: true,
                                        innerTabName: 'Screening Data',
                                        permission: ['dow-jones-list'],
                                    },
                                },
                                {
                                    path: '/configuration/screening-data/dow-jones/role-type',
                                    name: 'role-type',
                                    component: () =>
                                        import(
                                            './views/configuration/screening-data/dow-jones/RoleType.vue'
                                        ),
                                    meta: {
                                        showSideBar: true,
                                        selectedTab: 0,
                                        title: 'Configuration | Screening Data | Role Type',
                                        requiresAuth: true,
                                        innerTabName: 'Screening Data',
                                        permission: ['dow-jones-list'],
                                    },
                                },
                                {
                                    path: '/configuration/screening-data/dow-jones/occupation',
                                    name: 'occupation',
                                    component: () =>
                                        import(
                                            './views/configuration/screening-data/dow-jones/Occupation.vue'
                                        ),
                                    meta: {
                                        showSideBar: true,
                                        selectedTab: 0,
                                        title: 'Configuration | Screening Data | Occupation',
                                        responsiveMenuItem: true,
                                        requiresAuth: true,
                                        innerTabName: 'Screening Data',
                                        permission: ['dow-jones-list'],
                                    },
                                },
                                {
                                    path: '/configuration/screening-data/dow-jones/date-type',
                                    name: 'data-type',
                                    component: () =>
                                        import(
                                            './views/configuration/screening-data/dow-jones/DateType.vue'
                                        ),
                                    meta: {
                                        showSideBar: true,
                                        selectedTab: 0,
                                        title: 'Configuration | Screening Data | Date Type',
                                        responsiveMenuItem: true,
                                        requiresAuth: true,
                                        innerTabName: 'Screening Data',
                                        permission: ['dow-jones-list'],
                                    },
                                },
                                {
                                    path: '/configuration/screening-data/dow-jones/sanction-reference',
                                    name: 'sanction-reference',
                                    component: () =>
                                        import(
                                            './views/configuration/screening-data/dow-jones/SactionReference.vue'
                                        ),
                                    meta: {
                                        showSideBar: true,
                                        selectedTab: 0,
                                        title: 'Configuration | Screening Data | Sanction Reference',
                                        responsiveMenuItem: true,
                                        innerTabName: 'Screening Data',
                                        requiresAuth: true,
                                        permission: ['dow-jones-list'],
                                    },
                                },
                                {
                                    path: '/configuration/screening-data/dow-jones/country',
                                    name: 'screening-country',
                                    component: () =>
                                        import(
                                            './views/configuration/screening-data/dow-jones/Countries.vue'
                                        ),
                                    meta: {
                                        showSideBar: true,
                                        selectedTab: 0,
                                        title: 'Configuration | Screening Data | Countries',
                                        responsiveMenuItem: true,
                                        innerTabName: 'Screening Data',
                                        requiresAuth: true,
                                        permission: ['dow-jones-list'],
                                    },
                                },
                                {
                                    path: '/configuration/screening-data/dow-jones/country-type',
                                    name: 'screening-country-type',
                                    component: () =>
                                        import(
                                            './views/configuration/screening-data/dow-jones/CountryType.vue'
                                        ),
                                    meta: {
                                        showSideBar: true,
                                        selectedTab: 0,
                                        title: 'Configuration | Screening Data | Country Type',
                                        responsiveMenuItem: true,
                                        innerTabName: 'Screening Data',
                                        requiresAuth: true,
                                        permission: ['dow-jones-list'],
                                    },
                                },
                                {
                                    path: '/configuration/screening-data/dow-jones/identification',
                                    name: 'screening-indentification',
                                    component: () =>
                                        import(
                                            './views/configuration/screening-data/dow-jones/Identification.vue'
                                        ),
                                    meta: {
                                        showSideBar: true,
                                        selectedTab: 0,
                                        title: 'Configuration | Screening Data | Identification',
                                        responsiveMenuItem: true,
                                        innerTabName: 'Screening Data',
                                        requiresAuth: true,
                                        permission: ['dow-jones-list'],
                                    },
                                },
                                {
                                    path: '/configuration/screening-data/dow-jones/relationship-type',
                                    name: 'screening-relationship',
                                    component: () =>
                                        import(
                                            './views/configuration/screening-data/dow-jones/Relationship.vue'
                                        ),
                                    meta: {
                                        showSideBar: true,
                                        selectedTab: 0,
                                        title: 'Configuration | Screening Data | Relationship Type',
                                        responsiveMenuItem: true,
                                        innerTabName: 'Screening Data',
                                        requiresAuth: true,
                                        permission: ['dow-jones-list'],
                                    },
                                },
                            ],
                        },
                        {
                            path: '/',
                            name: 'client-black-list',
                            component: () =>
                                import(
                                    './views/configuration/screening-data/CustomBlacklisted.vue'
                                ),
                            children: [
                                // {
                                //     path: '/',
                                //     name: 'client-black-list',
                                //     component: () =>
                                //         import(
                                //              './views/configuration/screening-data/CustomBlacklisted.vue'
                                //         ),
                                //     meta: {
                                //         showSideBar: true,
                                //         selectedTab: 3,
                                //         innerTabName: 'Screening Data',
                                //         requiresAuth: true,
                                //         title: 'Configuration | Client Black List',
                                //         permission: ['client-black-list'],
                                //     },
                                // },
                                // {
                                //     path: '/configuration',
                                //     name: 'client-black-list',
                                //     component: () =>
                                //         import(
                                //              './views/configuration/screening-data/CustomBlacklisted.vue'
                                //         ),
                                //     meta: {
                                //         showSideBar: true,
                                //         selectedTab: 3,
                                //         innerTabName: 'Screening Data',
                                //         requiresAuth: true,
                                //         title: 'Configuration | Client Black List',
                                //         permission: ['client-black-list'],
                                //     },
                                // },
                                {
                                    path: '/configuration/screening-data/client-black-list',
                                    name: 'client-black-list',
                                    component: () =>
                                        import(
                                            './views/configuration/screening-data/CustomBlacklisted.vue'
                                        ),
                                    meta: {
                                        showSideBar: true,
                                        selectedTab: 3,
                                        innerTabName: 'Screening Data',
                                        requiresAuth: true,
                                        title: 'Configuration | Client Black List',
                                        permission: ['client-black-list'],
                                    },
                                },
                            ],
                        },
                        {
                            path: '/',
                            name: 'data-entry-list',
                            component: () =>
                                import(
                                    './views/configuration/screening-data/DataEntryListed.vue'
                                ),
                            children: [
                                {
                                    path: '/',
                                    name: 'data-entry-list',
                                    component: () =>
                                        import(
                                            './views/configuration/screening-data/DataEntryListed.vue'
                                        ),
                                    meta: {
                                        showSideBar: true,
                                        selectedTab: 3,
                                        innerTabName: 'Screening Data',
                                        requiresAuth: true,
                                        title: 'Configuration | Data Entry',
                                        permission: ['data-entry-list'],
                                    },
                                },
                                {
                                    path: '/configuration/screening-data/data-entry-list',
                                    name: 'data-entry-list',
                                    component: () =>
                                        import(
                                            './views/configuration/screening-data/DataEntryListed.vue'
                                        ),
                                    meta: {
                                        showSideBar: true,
                                        selectedTab: 3,
                                        innerTabName: 'Screening Data',
                                        requiresAuth: true,
                                        title: 'Configuration | Data Entry',
                                        permission: ['data-entry-list'],
                                    },
                                },
                            ],
                        },
                        {
                            path: '/',
                            name: 'idenfo-black-list',
                            component: () =>
                                import(
                                    './views/configuration/screening-data/Blacklisted.vue'
                                ),
                            children: [
                                {
                                    path: '/',
                                    name: 'idenfo-black-list',
                                    component: () =>
                                        import(
                                            './views/configuration/screening-data/Blacklisted.vue'
                                        ),
                                    meta: {
                                        showSideBar: true,
                                        selectedTab: 2,
                                        innerTabName: 'Screening Data',
                                        requiresAuth: true,
                                        title: 'Configuration | Idenfo Black List',
                                        permission: ['idenfo-black-list'],
                                    },
                                },
                                {
                                    path: '/configuration/screening-data/idenfo-black-list',
                                    name: 'idenfo-black-list',
                                    component: () =>
                                        import(
                                            './views/configuration/screening-data/Blacklisted.vue'
                                        ),
                                    meta: {
                                        showSideBar: true,
                                        selectedTab: 2,
                                        innerTabName: 'Screening Data',
                                        requiresAuth: true,
                                        title: 'Configuration | Idenfo Black List',
                                        permission: ['idenfo-black-list'],
                                    },
                                },
                            ],
                        },
                        {
                            path: '/configuration/screening-data/date-type',
                            name: 'data-type',
                            component: () =>
                                import(
                                    './views/configuration/screening-data/DateType.vue'
                                ),
                            meta: {
                                showSideBar: true,
                                selectedTab: 0,
                                title: 'Configuration | Screening Data | Date Type',
                                responsiveMenuItem: true,
                                requiresAuth: true,
                                innerTabName: 'Screening Data',
                                permission: ['view-screening-data'],
                            },
                        },
                        {
                            path: '/configuration/screening-data/sanction-reference',
                            name: 'sanction-reference',
                            component: () =>
                                import(
                                    './views/configuration/screening-data/SactionReference.vue'
                                ),
                            meta: {
                                showSideBar: true,
                                selectedTab: 0,
                                title: 'Configuration | Screening Data | Sanction Reference',
                                responsiveMenuItem: true,
                                innerTabName: 'Screening Data',
                                requiresAuth: true,
                                permission: ['view-screening-data'],
                            },
                        },
                        {
                            path: '/configuration/screening-data/country',
                            name: 'screening-country',
                            component: () =>
                                import(
                                    './views/configuration/screening-data/Countries.vue'
                                ),
                            meta: {
                                showSideBar: true,
                                selectedTab: 0,
                                title: 'Configuration | Screening Data | Countries',
                                responsiveMenuItem: true,
                                innerTabName: 'Screening Data',
                                requiresAuth: true,
                                permission: ['view-screening-data'],
                            },
                        },
                        {
                            path: '/configuration/screening-data/country-type',
                            name: 'screening-country-type',
                            component: () =>
                                import(
                                    './views/configuration/screening-data/CountryType.vue'
                                ),
                            meta: {
                                showSideBar: true,
                                selectedTab: 0,
                                title: 'Configuration | Screening Data | Country Type',
                                responsiveMenuItem: true,
                                innerTabName: 'Screening Data',
                                requiresAuth: true,
                                permission: ['view-screening-data'],
                            },
                        },
                        {
                            path: '/configuration/screening-data/identification',
                            name: 'screening-indentification',
                            component: () =>
                                import(
                                    './views/configuration/screening-data/Identification.vue'
                                ),
                            meta: {
                                showSideBar: true,
                                selectedTab: 0,
                                title: 'Configuration | Screening Data | Identification',
                                responsiveMenuItem: true,
                                innerTabName: 'Screening Data',
                                requiresAuth: true,
                                permission: ['view-screening-data'],
                            },
                        },
                        {
                            path: '/configuration/screening-data/relationship-type',
                            name: 'screening-relationship',
                            component: () =>
                                import(
                                    './views/configuration/screening-data/Relationship.vue'
                                ),
                            meta: {
                                showSideBar: true,
                                selectedTab: 0,
                                title: 'Configuration | Screening Data | Relationship Type',
                                responsiveMenuItem: true,
                                innerTabName: 'Screening Data',
                                requiresAuth: true,
                                permission: ['view-screening-data'],
                            },
                        },

                        // world check routes
                        {
                            path: '/configuration/screening-data/world-check',
                            name: 'world-check-category',
                            component: () =>
                                import(
                                    './views/configuration/screening-data/world-check/Category.vue'
                                ),
                            meta: {
                                showSideBar: true,
                                selectedTab: 1,
                                innerTabName: 'Screening Data',
                                requiresAuth: true,
                                title: 'Configuration | World Check | Category',
                                permission: ['view-screening-data'],
                            },
                        },
                        {
                            path: '/configuration/screening-data/world-check/category',
                            name: 'world-check-category',
                            component: () =>
                                import(
                                    './views/configuration/screening-data/world-check/Category.vue'
                                ),
                            meta: {
                                showSideBar: true,
                                selectedTab: 1,
                                innerTabName: 'Screening Data',
                                requiresAuth: true,
                                title: 'Configuration | World Check | Category',
                                permission: ['view-screening-data'],
                            },
                        },
                        {
                            path: '/configuration/screening-data/world-check/sub-category',
                            name: 'world-check-sub-category',
                            component: () =>
                                import(
                                    './views/configuration/screening-data/world-check/SubCategory.vue'
                                ),
                            meta: {
                                showSideBar: true,
                                selectedTab: 1,
                                innerTabName: 'Screening Data',
                                requiresAuth: true,
                                title: 'Configuration | World Check | Sub-Category',
                                permission: ['view-screening-data'],
                            },
                        },
                        {
                            path: '/configuration/screening-data/world-check/deceased',
                            name: 'world-check-deceased',
                            component: () =>
                                import(
                                    './views/configuration/screening-data/world-check/Deceased.vue'
                                ),
                            meta: {
                                showSideBar: true,
                                selectedTab: 1,
                                innerTabName: 'Screening Data',
                                requiresAuth: true,
                                title: 'Configuration | World Check | Deceased',
                                permission: ['view-screening-data'],
                            },
                        },
                        {
                            path: '/configuration/screening-data/world-check/location',
                            name: 'world-check-location',
                            component: () =>
                                import(
                                    './views/configuration/screening-data/world-check/Locations.vue'
                                ),
                            meta: {
                                showSideBar: true,
                                selectedTab: 1,
                                innerTabName: 'Screening Data',
                                requiresAuth: true,
                                title: 'Configuration | World Check | Locations',
                                permission: ['view-screening-data'],
                            },
                        },
                        {
                            path: '/configuration/screening-data/world-check/EIType',
                            name: 'world-check-eitype',
                            component: () =>
                                import(
                                    './views/configuration/screening-data/world-check/EIType.vue'
                                ),
                            meta: {
                                showSideBar: true,
                                selectedTab: 1,
                                innerTabName: 'Screening Data',
                                requiresAuth: true,
                                title: 'Configuration | World Check | E/I Type',
                                permission: ['view-screening-data'],
                            },
                        },
                        {
                            path: '/configuration/screening-data/world-check/keyword',
                            name: 'world-check-keyword',
                            component: () =>
                                import(
                                    './views/configuration/screening-data/world-check/Keyword.vue'
                                ),
                            meta: {
                                showSideBar: true,
                                selectedTab: 1,
                                innerTabName: 'Screening Data',
                                requiresAuth: true,
                                title: 'Configuration | World Check | Keyword',
                                permission: ['view-screening-data'],
                            },
                        },
                        {
                            path: '/configuration/screening-data/world-check/update-category',
                            name: 'world-check-update-category',
                            component: () =>
                                import(
                                    './views/configuration/screening-data/world-check/UpdateCategory.vue'
                                ),
                            meta: {
                                showSideBar: true,
                                selectedTab: 1,
                                innerTabName: 'Screening Data',
                                requiresAuth: true,
                                title: 'Configuration | World Check | Update Category',
                                permission: ['view-screening-data'],
                            },
                        },
                        {
                            path: '/configuration/screening-data/world-check/pep-status',
                            name: 'world-check-pep-status',
                            component: () =>
                                import(
                                    './views/configuration/screening-data/world-check/PepStatus.vue'
                                ),
                            meta: {
                                showSideBar: true,
                                selectedTab: 1,
                                innerTabName: 'Screening Data',
                                requiresAuth: true,
                                title: 'Configuration | World Check | PEP Status',
                                permission: ['view-screening-data'],
                            },
                        },
                        {
                            path: '/configuration/screening-data/delta-list',
                            name: 'delta-list',
                            component: () =>
                                import(
                                    './views/configuration/screening-data/Deltalisted.vue'
                                ),
                            meta: {
                                showSideBar: true,
                                selectedTab: 3,
                                innerTabName: 'Screening Data',
                                requiresAuth: true,
                                title: 'Idenfo Delta List',
                                permission: ['view-screening-data'],
                            },
                        },
                    ],
                },
                {
                    path: '/configuration/simulate/',
                    name: 'initiate-simulation-process',
                    component: () =>
                        import('./views/configuration/Simulate.vue'),
                    meta: {
                        showSideBar: true,

                        title: 'Configuration | Simulation Switch',
                        requiresAuth: true,
                        permission: ['initiate-simulation-process'],
                    },
                },

                {
                    path: '/configuration/form-builder/',
                    name: 'form-builder',
                    component: () =>
                        import('./views/configuration/form-builder/Main.vue'),
                    children: [
                        {
                            path: '/',
                            name: 'form-builder-setup-profile',
                            component: () =>
                                import(
                                    './views/configuration/form-builder/SetupProfile.vue'
                                ),
                            meta: {
                                showSideBar: true,

                                title: 'Configuration | Registration Form Builder | Setup Profile',
                                requiresAuth: true,
                                permission: ['form-builder'],
                                formBuilder: 'setup-profile',
                                innerTabName: 'Form Builder',
                            },
                        },
                        {
                            path: '/configuration/form-builder/account-info',
                            name: 'form-builder-account-info',
                            component: () =>
                                import(
                                    './views/configuration/form-builder/SetupProfile.vue'
                                ),
                            meta: {
                                showSideBar: true,

                                title: 'Configuration | Registration Form Builder | Account Information',
                                requiresAuth: true,
                                permission: ['form-builder'],
                                formBuilder: 'account-info',
                                innerTabName: 'Form Builder',
                            },
                        },
                        {
                            path: '/configuration/form-builder/preview-form/:name',
                            name: 'preview_form',
                            component: () =>
                                import(
                                    './views/configuration/form-builder/PreviewRegistrationForm.vue'
                                ),
                            meta: {
                                showSideBar: true,

                                title: 'Configuration | Registration Form Builder | Preview Registration Form',
                                requiresAuth: true,
                                previewForm: true,
                                permission: ['form-builder'],
                                innerTabName: 'Form Builder',
                            },
                        },
                    ],
                },

                {
                    path: '/configuration/branding/',
                    name: 'branding',
                    component: () =>
                        import('./views/configuration/Branding.vue'),
                    meta: {
                        showSideBar: true,

                        title: 'Configuration | Branding Configurations',
                        requiresAuth: true,
                        permission: ['branding'],
                    },
                },
                {
                    path: '/configuration/on-boarding-configuration/',
                    name: 'on-boarding-configuration',
                    component: () =>
                        import('./views/configuration/OnBoardingCustomer.vue'),
                    meta: {
                        showSideBar: true,

                        title: 'Configuration | On Boarding Configuration',
                        requiresAuth: true,
                        permission: ['ocr'],
                    },
                },
            ],
        },
        {
            path: '/register-customer',
            name: 'register-customer',
            component: () => import('./views/register-customer/Main.vue'),
            children: [
                {
                    path: '/',
                    name: 'setup-profile',
                    component: () =>
                        import('./views/register-customer/SetupProfile.vue'),
                    meta: {
                        showSideBar: true,

                        name: 'Register Customers',
                        title: 'Register Customer | Setup Profile',
                        sessionStep: '2',
                        requiresAuth: true,
                        permission: ['register-customer'],
                    },
                },

                {
                    // {
                    //     path: '/register-customer/record-video',
                    //     name: 'record-video',
                    //     component: () =>
                    //         import( './views/register-customer/RecordVideo.vue'),
                    //     meta: {
                    //         showSideBar: true,

                    //         name: 'Register Customers',
                    //         title: 'Register Customer | Record Video',
                    //         sessionStep: '2',
                    //         requiresAuth: true,
                    //         permission: ['register-customer'],
                    //     },
                    // },

                    path: '/register-customer/setup-profile',
                    name: 'setup-profile',
                    component: () =>
                        import('./views/register-customer/SetupProfile.vue'),
                    meta: {
                        showSideBar: true,

                        name: 'Register Customers',
                        title: 'Register Customer | Setup Profile',
                        sessionStep: '2',
                        requiresAuth: true,
                        permission: ['register-customer'],
                    },
                },
                // {
                //     path: '/register-customer/account-info',
                //     name: 'account-info',
                //     component: () =>
                //         import(
                //              './views/register-customer/AccountInfo.vue'
                //         ),
                //     meta: {
                //         showSideBar: true,

                //         name: 'Register Customers',
                //         title: 'Register Customer | Account Info',
                //         sessionStep: '3',
                //         requiresAuth: true,
                //         permission: ['register-customer'],
                //     },
                // },
                // {
                //     path: '/register-customer/kyc',
                //     name: 'kyc',
                //     component: () =>
                //         import(
                //             './views/register-customer/KYC.vue'
                //         ),
                //     meta: {
                //         showSideBar: true,

                //         name: 'Register Customers',
                //         title: 'Register Customer | KYC',
                //         sessionStep: '4',
                //         requiresAuth: true,
                //         permission: ['register-customer'],
                //     },
                // },
                // {
                //     path: '/register-customer/investment',
                //     name: 'investment',
                //     component: () =>
                //         import(
                //              './views/register-customer/Investment.vue'
                //         ),
                //     meta: {
                //         showSideBar: true,

                //         name: 'Register Customers',
                //         title: 'Register Customer | Investment',
                //         sessionStep: '5',
                //         requiresAuth: true,
                //         permission: ['register-customer'],
                //     },
                // },
                // {
                //     path: '/register-customer/risk-product',
                //     name: 'risk-product',
                //     component: () =>
                //         import(
                //              './views/register-customer/RiskProduct.vue'
                //         ),
                //     meta: {
                //         showSideBar: true,

                //         name: 'Register Customers',
                //         title: 'Register Customer | Risk Product',
                //         sessionStep: '6',
                //         requiresAuth: true,
                //         permission: ['register-customer'],
                //     },
                // },
                // {
                //     path: '/register-customer/upload-document',
                //     name: 'upload-document',
                //     props: true,
                //     component: () =>
                //         import(
                //              './views/register-customer/UploadDocuments.vue'
                //         ),
                //     meta: {
                //         showSideBar: true,

                //         name: 'Online Account Opening Application',
                //         title: 'Public Registration | Upload Document',
                //         sessionStep: '7',
                //         requiresAuth: true,
                //         permission: ['register-customer'],
                //     },
                // },

                // {
                //     path: '/register-customer/preview',
                //     name: 'preview',
                //     component: () =>
                //         import(
                //             './views/register-customer/Preview.vue'
                //         ),
                //     meta: {
                //         showSideBar: true,
                //         props: true,
                //         name: 'Preview Details',
                //         title: 'Register Customer | Preview',
                //         sessionStep: '8',
                //         requiresAuth: true,
                //         permission: ['register-customer'],
                //     },
                // },
                {
                    path: '/register-customer/finish',
                    name: 'finish',
                    component: () =>
                        import('./views/register-customer/Finish.vue'),
                    meta: {
                        showSideBar: true,

                        name: 'Register Customers',
                        title: 'Register Customer | Finish',
                        sessionStep: '8',
                        requiresAuth: true,
                        permission: ['register-customer'],
                    },
                },
            ],
        },

        {
            path: '/:dataSegmentId/register',
            name: 'register-customer',
            props: true,
            component: () => import('./views/register-customer/Main.vue'),
            children: [
                {
                    path: '/',
                    name: 'public-registration-setup-profile',
                    props: true,
                    component: () =>
                        import('./views/register-customer/SetupProfile.vue'),
                    meta: {
                        name: 'Online Account Opening Application',
                        title: 'Public Registration | Setup Profile',
                        sessionStep: '2',
                        showSideBar: false,
                        publicRegistration: true,
                        bodyClass: 'auth-body',
                    },
                },
                // {
                //     path: '/:dataSegmentId/register/record-video',
                //     name: 'public-registration-record-video',
                //     props: true,
                //     component: () =>
                //         import( './views/register-customer/RecordVideo.vue'),
                //     meta: {
                //         name: 'Online Account Opening Application',
                //         title: 'Public Registration | Record Video',
                //         sessionStep: '2',
                //         showSideBar: false,
                //         publicRegistration: true,
                //         bodyClass: 'auth-body',
                //     },
                // },
                {
                    path: '/:dataSegmentId/register/setup-profile',
                    name: 'public-registration-setup-profile',
                    props: true,
                    component: () =>
                        import('./views/register-customer/SetupProfile.vue'),
                    meta: {
                        name: 'Online Account Opening Application',
                        title: 'Public Registration | Setup Profile',
                        sessionStep: '2',
                        showSideBar: false,
                        publicRegistration: true,
                        bodyClass: 'auth-body',
                    },
                },
                // {
                //     path: '/:dataSegmentId/register/account-info',
                //     name: 'public-registration-account-info',
                //     props: true,
                //     component: () =>
                //         import (
                //             './views/register-customer/AccountInfo.vue'
                //         ),
                //     meta: {
                //         name: 'Online Account Opening Application',
                //         title: 'Public Registration | Account Info',
                //         sessionStep: '3',
                //         showSideBar: false,
                //         publicRegistration: true,
                //         bodyClass: 'auth-body',
                //     },
                // },
                // {
                //     path: '/:dataSegmentId/register/kyc',
                //     name: 'public-registration-kyc',
                //     component: () =>
                //         import (
                //             './views/register-customer/KYC.vue'
                //         ),
                //     meta: {
                //         name: 'Register Customers',
                //         title: 'Register Customer | KYC',
                //         sessionStep: '4',
                //         showSideBar: false,
                //         publicRegistration: true,
                //         bodyClass: 'auth-body',
                //     },
                // },
                // {
                //     path: '/:dataSegmentId/register/investment',
                //     name: 'public-registration-investment',
                //     props: true,
                //     component: () =>
                //         import (
                //             './views/register-customer/Investment.vue'
                //         ),
                //     meta: {
                //         name: 'Online Account Opening Application',
                //         title: 'Public Registration | Investment',
                //         sessionStep: '5',
                //         showSideBar: false,
                //         publicRegistration: true,
                //         bodyClass: 'auth-body',
                //     },
                // },
                // {
                //     path: '/:dataSegmentId/register/risk-product',
                //     name: 'public-registration-risk-product',
                //     props: true,
                //     component: () =>
                //         import (
                //             './views/register-customer/RiskProduct.vue'
                //         ),
                //     meta: {
                //         name: 'Online Account Opening Application',
                //         title: 'Public Registration | Risk Product',
                //         sessionStep: '6',
                //         showSideBar: false,
                //         publicRegistration: true,
                //         bodyClass: 'auth-body',
                //     },
                // },
                // {
                //     path: '/:dataSegmentId/register/upload-document',
                //     name: 'public-registration-upload-document',
                //     props: true,
                //     component: () =>
                //         import (
                //             './views/register-customer/UploadDocuments.vue'
                //         ),
                //     meta: {
                //         name: 'Online Account Opening Application',
                //         title: 'Public Registration | Upload Document',
                //         sessionStep: '7',
                //         showSideBar: false,
                //         publicRegistration: true,
                //         bodyClass: 'auth-body',
                //     },
                // },
                // {
                //     path: '/:dataSegmentId/register/preview',
                //     name: 'public-registration-preview',
                //     props: true,
                //     component: () =>
                //         import (
                //             './views/register-customer/Preview.vue'
                //         ),
                //     meta: {
                //         name: 'Online Account Opening Application',
                //         title: 'Public Registration | Preview',
                //         sessionStep: '8',
                //         showSideBar: false,
                //         publicRegistration: true,
                //         bodyClass: 'auth-body',
                //     },
                // },
                {
                    path: '/:dataSegmentId/register/finish',
                    name: 'public-registration-finish',
                    props: true,
                    component: () =>
                        import('./views/register-customer/Finish.vue'),
                    meta: {
                        name: 'Online Account Opening Application',
                        title: 'Public Registration | Finish',
                        sessionStep: '2',
                        showSideBar: false,
                        publicRegistration: true,
                        bodyClass: 'auth-body',
                    },
                },
            ],
        },
        {
            path: '/details-form',
            name: 'details-form',
            component: () => import('./views/details-form/Main.vue'),
            children: [
                {
                    path: '/',
                    name: 'setup-profile',
                    component: () =>
                        import('./views/details-form/SetupProfile.vue'),
                    meta: {
                        showSideBar: true,

                        name: 'Personal Info',
                        title: 'Register Investor | Personal Info',
                        sessionStep: '1',
                        requiresAuth: true,
                        permission: ['details-form'],
                    },
                },
                {
                    path: '/details-form/account-info',
                    name: 'account-info',
                    component: () =>
                        import('./views/details-form/AccountInfo.vue'),
                    meta: {
                        showSideBar: true,

                        name: 'Account Info',
                        title: 'Register Customer | Account Info',
                        sessionStep: '2',
                        bodyClass: 'register-customer-body',
                        requiresAuth: true,
                        permission: ['details-form'],
                    },
                },
                {
                    path: '/details-form/attorney-info',
                    name: 'attorney-info',
                    component: () =>
                        import('./views/details-form/AttorneyInfo.vue'),
                    meta: {
                        showSideBar: true,

                        name: 'Attorney Info',
                        title: 'Register Customer | Attorney Info',
                        sessionStep: '3',
                        bodyClass: 'register-customer-body',
                        requiresAuth: true,
                        permission: ['details-form'],
                    },
                },
                {
                    path: '/details-form/nominee-info',
                    name: 'nominee-info',
                    component: () =>
                        import('./views/details-form/NomineeInfo.vue'),
                    meta: {
                        showSideBar: true,

                        name: 'Nominee Info',
                        title: 'Register Customer | Nominee Info',
                        sessionStep: '4',
                        bodyClass: 'register-customer-body',
                        requiresAuth: true,
                        permission: ['details-form'],
                    },
                },
                {
                    path: '/details-form/upload-document',
                    name: 'upload-document',
                    component: () =>
                        import(
                            './views/details-form/UploadInvestorDocuments.vue'
                        ),
                    meta: {
                        showSideBar: true,

                        name: 'Upload Documents',
                        title: 'Details Form | Upload Document',
                        sessionStep: '5',
                        requiresAuth: true,
                        permission: ['details-form'],
                    },
                },
                {
                    path: '/details-form/finish',
                    name: 'finish',
                    component: () => import('./views/details-form/Finish.vue'),
                    meta: {
                        showSideBar: true,

                        name: 'Finish',
                        title: 'Register Customer | Finish',
                        sessionStep: '6',
                        bodyClass: 'register-customer-body',
                        requiresAuth: true,
                        permission: ['details-form'],
                    },
                },
                // {
                //     path: '/register-customer/setup-profile',
                //     name: 'setup-profile',
                //     component: () =>
                //         import( './views/details-form/SetupProfile.vue'),
                //     meta: {
                //         showSideBar: true,
                //
                //         name: 'Register Investor',
                //         title: 'Register Customer | Setup Profile',
                //         sessionStep: '3',
                //         requiresAuth: true,
                //         permission: ['details-form'],
                //     },
                // }
            ],
        },
    ],
})
